export default "__VITE_ASSET__IrlxPxvz__"